"use client";

import { useParams, usePathname } from "next/navigation";

import StateDropdown from "@/app/(discover)/components/state-dropdown";
import routes from "@/lib/routes";
import {
  defaultState,
  getStateConfigFromString,
  type StateConfig,
} from "@/lib/states-config";

function useCurrentState(): StateConfig {
  const params = useParams<{ stateName?: string }>();

  if (params.stateName) {
    const state = getStateConfigFromString(params.stateName);
    if (state) return state;
  }

  return defaultState;
}

export function StateDropdownWrapper() {
  const currentState = useCurrentState();
  const pathname = usePathname();
  const stateRoute = routes.getJobsState({ state: currentState });
  if (pathname !== stateRoute) {
    return null;
  }
  return <StateDropdown currentState={currentState} />;
}
